/**
 * Centralized SEO & AEO Keywords Configuration
 * Use this file to update search engine visibility for both Romanian and English markets.
 */

export const seoConfig = {
  ro: {
    title: "Cazare Iași | Apartamente, Vile și Pensiuni - Site2Rent",
    defaultDescription: "Găsește cea mai bună cazare în Iași. Oferim opțiuni diverse: cazare apartamente în Iași, la vilă, tip pensiune, în centru sau lângă aeroport. Rezervări sigure prin Stripe.",
    
    // Core Keywords (Short-tail)
    keywords: [
      "cazare in Iasi",
      "Cazare apartamente in Iasi",
      "Cazare la vila",
      "cazare tip pensiune",
      "Cazare linga aeroport",
      "cazare in centru iasi",
      "regim hotelier iasi",
      "inchirieri apartamente iasi",
      "pensiuni iasi"
    ],

    // AEO Questions (Targeting Answer Engines/Voice Search)
    aeoQuestions: [
      {
        q: "Unde găsesc cazare ieftină în centru Iași?",
        a: "Site2Rent oferă o selecție vastă de apartamente în regim hotelier chiar în centrul Iașului, cu prețuri competitive și plată securizată."
      },
      {
        q: "Există cazare la vilă în Iași aproape de aeroport?",
        a: "Da, prin platforma noastră poți rezerva vile și pensiuni dotate modern, situate la doar câteva minute de Aeroportul Internațional Iași."
      },
      {
        q: "Cum pot închiria un apartament în Iași în siguranță?",
        a: "Folosind Site2Rent, tranzacțiile sunt procesate prin Stripe Connect, asigurând protecția banilor tăi până la check-in."
      }
    ],

    // Semantic tags for categorization
    categories: {
      location: ["Centru", "Copou", "Păcurari", "Tătărași", "Aeroport"],
      type: ["Apartament", "Vilă", "Pensiune", "Studio", "Casă întreagă"]
    }
  },
  
  en: {
    title: "Accommodation Iași | Apartments, Villas & Guesthouses - Site2Rent",
    defaultDescription: "Find the best accommodation in Iași. We offer diverse options: apartments in Iași, villas, guesthouses, city center stays, or near the airport. Secure bookings via Stripe.",
    
    keywords: [
      "accommodation in Iasi",
      "apartments in Iasi",
      "villa rentals Iasi",
      "guesthouses Iasi",
      "accommodation near Iasi airport",
      "city center Iasi stays",
      "short term rentals Iasi",
      "hotel apartments Iasi"
    ],

    aeoQuestions: [
      {
        q: "Where to find affordable accommodation in Iași city center?",
        a: "Site2Rent provides a wide range of serviced apartments in the heart of Iași with secure payment options."
      },
      {
        q: "Are there villas for rent near Iași Airport?",
        a: "Yes, our platform features premium villas and guesthouses located conveniently close to Iași International Airport."
      }
    ],

    categories: {
      location: ["City Center", "Copou District", "Airport Area"],
      type: ["Apartment", "Villa", "Guesthouse", "Studio"]
    }
  }
};